import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingService } from '../../shared/service/onboarding.service';
import { OnboardEducationDetails } from 'src/app/shared/models/OnboardEducationDetails';
import { FormControl, FormGroup, FormArray, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { OnboardPreviousEmploymentDetails } from 'src/app/shared/models/OnboardPreviousEmploymentDetails';
import { OnboardProfessionalReferenceDetails } from 'src/app/shared/models/OnboardProfessionalReferenceDetails';
import { OnboardEmergencyContactDetails } from 'src/app/shared/models/OnboardEmergencyContactDetails';
import { MatDialog, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { OnboardVrifications } from 'src/app/shared/models/OnboardVrifications';
import { UserService } from 'src/app/shared/service/user.service';
import { OnboardEmployeeDetails } from 'src/app/shared/models/OnboardEmployeeDetails';
import { OnboardEmployeePersonalDetails } from 'src/app/shared/models/OnboardEmployeePersonalDetails';
import { OnboardEmployeePassportVisaInfo } from 'src/app/shared/models/OnboardEmployeePassportVisaInfo';
import { OnboardEmployeeFinanceDetails } from 'src/app/shared/models/OnboardEmployeeFinanceDetails';
import { AppConfig } from 'src/app/app.config';
import * as _moment from 'moment';
import { DatePipe } from '@angular/common';
import { OnboardingExportToEmp } from 'src/app/shared/models/onboardingExportToEmp';
import { EmployeeService } from 'src/app/shared/service/employee.service';
import { PreviousEmploymentComponent } from 'src/app/onboarding/previous-employment/previous-employment.component';
import { BasicEmpDetailsComponent } from 'src/app/onboarding/basic-emp-details/basic-emp-details.component';
import { PersonalDetailsComponent } from 'src/app/onboarding/personal-details/personal-details.component';
import { EducationDetailsComponent } from 'src/app/onboarding/education-details/education-details.component';
import { ReferenceDetailsComponent } from 'src/app/onboarding/reference-details/reference-details.component';
import { PassportvisaInformationComponent } from 'src/app/onboarding/passportvisa-information/passportvisa-information.component';
import { FinanceDetailsComponent } from 'src/app/onboarding/finance-details/finance-details.component';
import { ComponentIdentificationService } from 'src/app/shared/service/component-identification.service';
import { isNullOrUndefined } from 'util';
import { OnboardEmpEducationInformation } from 'src/app/shared/models/OnboardEmpEducationInformation';
import { EmployeeModel } from 'src/app/shared/models/employee.model';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

@Component({
  selector: 'app-my-profile-summary',
  templateUrl: './my-profile-summary.component.html',
  styleUrls: ['./my-profile-summary.component.css']
})
export class MyProfileSummaryComponent implements OnInit {
  @ViewChild(BasicEmpDetailsComponent, { static: false }) basicEmpDetComponent: BasicEmpDetailsComponent;
  @ViewChild(PersonalDetailsComponent, { static: false }) personalDetailsComponent: PersonalDetailsComponent;
  @ViewChild(EducationDetailsComponent, { static: false }) educationDetailsComponent: EducationDetailsComponent;
  @ViewChild(PreviousEmploymentComponent, { static: false }) previousEmploymentComponent: PreviousEmploymentComponent;
  //@ViewChild(ReferenceDetailsComponent, { static: false }) referenceDetailsComponent: ReferenceDetailsComponent;
  @ViewChild(PassportvisaInformationComponent, { static: false }) passportvisaInformationComponent: PassportvisaInformationComponent;
  @ViewChild(FinanceDetailsComponent, { static: false }) financeDetailsComponent: FinanceDetailsComponent;
  MAX_SIZE: number = 1048576;
  slug: any;
  VerificationDetails: OnboardVrifications[] = [];
  EmpId: number;
  error: string;
  ngOnInit() {

  }
  constructor(private _service: OnboardingService) {

  }
  GetVerificationStatus() {
    this._service.GetVerificationStatus(this.EmpId).subscribe((data: any) => {
      this.VerificationDetails = data;

      //count 6 indicates that all the tabs are verified

    }, error => this.error = error)
  }
}



